import { c as _c } from "react/compiler-runtime";
import { Icon } from '~/components/primitives';
export const UspListItem: React.FC<{
  icon: Icon.Name;
  title: React.ReactNode;
  children?: React.ReactNode;
  testId?: string;
}> = props => {
  const $ = _c(13);
  let t0;
  if ($[0] !== props.icon) {
    t0 = <Icon name={props.icon} className="text-tertiary" />;
    $[0] = props.icon;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props.testId || $[3] !== props.title) {
    t1 = <p className="text-primary" data-testid={props.testId}>{props.title}</p>;
    $[2] = props.testId;
    $[3] = props.title;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props.children) {
    t2 = <p className="text-sm text-blue-500">{props.children}</p>;
    $[5] = props.children;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== t1 || $[8] !== t2) {
    t3 = <div>{t1}{t2}</div>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== t0 || $[11] !== t3) {
    t4 = <div className="flex items-start gap-3">{t0}{t3}</div>;
    $[10] = t0;
    $[11] = t3;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  return t4;
};